import { 
    SET_PROJECT_NAME, 
    SET_PROJECT_EMAIL, 
    SET_USER_TYPE, 
    PLUS_MINUS_SELECT,
    CREATE_AMBIENTES,
    SET_PROJECT_MATERIALS,
    SET_STEP_DONE,
    SELECT_AMBIENT_EDIT,
    REMOVE_PROJECT_AMBIENT,
    EDIT_NEXT_PROJECT,
    SET_UPLOAD_FILE,
    UPDATE_CURRENT_PROJECT,
    START_PROJECT,
    UNSET_PROJECT_MATERIALS,
    DELETE_PROJECT_AMBIENT,
    DELETE_PROJECT_AMBIENT_NOT_COMPLETED,
    FROM_COMPARATOR_NATERIALS,
    SET_FROM_COMPARATOR_NATERIALS,
    GOT_IN_MOODBOARD,
    PROJECT_WAS_SENT,
    SET_PROJECT_CODE,
    REMOVE_UPLOAD,
    CLEAR_STATE
  } from './types'
  import { 
    PLUS_ACTION, 
    MINUS_ACTION,
    STEP_PROJECT_NAME 
  } from '../helpers/enum'
  
  import Bathroom from '../assets/img/step_ambient_mobile/bathroom.svg'
  import FirePlace from '../assets/img/step_ambient_mobile/fireplace.svg'
  import FloorAndThreshold from '../assets/img/step_ambient_mobile/floor_and_threshold.svg'
  import Grill from '../assets/img/step_ambient_mobile/grill.svg'
  import Kitchen from '../assets/img/step_ambient_mobile/kitchen.svg'
  import Others from '../assets/img/step_ambient_mobile/others.svg'
  import ServiceArea from '../assets/img/step_ambient_mobile/service_area.svg'
  import Stairs from '../assets/img/step_ambient_mobile/stairs.svg'
  import Threshold from '../assets/img/step_ambient_mobile/threshold.svg'
  import Toilet from '../assets/img/step_ambient_mobile/toilet.svg'
  
  import BathroomDesk from '../assets/img/step_ambient_mobile/bathroom_desk.png'
  import FirePlaceDesk from '../assets/img/step_ambient_mobile/fireplace_desk.png'
  import FloorAndThresholdDesk from '../assets/img/step_ambient_mobile/floor_and_threshold_desk.png'
  import GrillDesk from '../assets/img/step_ambient_mobile/grill_desk.png'
  import KitchenDesk from '../assets/img/step_ambient_mobile/kitchen_desk.png'
  import OthersDesk from '../assets/img/step_ambient_mobile/others_desk.png'
  import ServiceAreaDesk from '../assets/img/step_ambient_mobile/service_area_desk.png'
  import StairsDesk from '../assets/img/step_ambient_mobile/stairs_desk.png'
  import ThresholdDesk from '../assets/img/step_ambient_mobile/threshold_desk.png'
  import ToiletDesk from '../assets/img/step_ambient_mobile/toilet_desk.png'
  
  const projectUserState = {
      steps: [{
        key: STEP_PROJECT_NAME,
        completed: false
      },{
        key: 2,
        completed: false
      }],
      project_started: false,
      project_name: '',
      project_email: '',
      user_type: '',
      materials: [],
      projects: [],
      projects_materials: [],
      files: [],
      from_comparator: false,
      got_in_moodboard: false,
      project_was_sent: false,
      project_code: null,
      ambients: [{
        name: 'cozinha',
        mobile_picture: Kitchen,
        desktop_picture: KitchenDesk,
        counter: 0
      },{
        name: 'churrasqueira',
        mobile_picture: Grill,
        desktop_picture: GrillDesk,
        counter: 0
      },{
        name: 'área de serviço',
        mobile_picture: ServiceArea,
        desktop_picture: ServiceAreaDesk,
        counter: 0
      },{
        name: 'lavabo',
        mobile_picture: Toilet,
        desktop_picture: ToiletDesk,
        counter: 0
      },{
        name: 'lareira',
        mobile_picture: FirePlace,
        desktop_picture: FirePlaceDesk,
        counter: 0
      },{
        name: 'banheiro',
        mobile_picture: Bathroom,
        desktop_picture: BathroomDesk,
        counter: 0
      },{
        name: 'escadas',
        mobile_picture: Stairs,
        desktop_picture: StairsDesk,
        counter: 0
      },{
        name: 'soleira e baguete',
        mobile_picture: Threshold,
        desktop_picture: ThresholdDesk,
        counter: 0
      },{
        name: 'piso e revestimento',
        mobile_picture: FloorAndThreshold,
        desktop_picture: FloorAndThresholdDesk,
        counter: 0
      },
      {
        name: 'outros',
        mobile_picture: Others,
        desktop_picture: OthersDesk,
        counter: 0
      }]
  }
  
  const updateAmbientsCounter = (ambients, name, action) => {
  
    const newMap = ambients.map(item => {
  
      let copy = { ...item }
  
      if (copy.name === name && action === PLUS_ACTION && copy.counter < 5) {
        copy.counter = copy.counter + 1
      }
  
      if (copy.name === name && action === MINUS_ACTION && copy.counter > 0) {
        copy.counter = copy.counter - 1
      }
  
      return copy
  
    })
  
    return newMap
  
  }
  
  const updateStepsComplete = (key, steps) => {
    let copy = [ ...steps ]
    const result = copy.map(item => {
      if (item.key === key) {
        item.completed = true
      }
      return item
    })
    return result
  }
  
  const createProjects = (ambients, project_list) => {
  
    let selectedProjects = ambients.filter(item => item.counter > 0)
  
    let projects = []
  
    for (let i = 0; i < selectedProjects.length; i++) {
  
      if (selectedProjects[i].counter > 1) {
  
          for (let j = 0; j < selectedProjects[i].counter; j++) {
  
            const { counter, ...rest } = selectedProjects[i]
  
            if (project_list.length > 0) {
  
              const filterCompleted = project_list.filter(proj => proj.completed && proj.type === selectedProjects[i].name)
  
              const foundSameName = filterCompleted.find(curp => curp.name === `${selectedProjects[i].name} (${j + 1})`)
  
              if (foundSameName) {
  
                projects.push({ ...foundSameName })
  
              } else {
  
                projects.push({ ...rest, 
                  materials: [],
                  description: '',
                  name: `${rest.name} (${j + 1})`,
                  selected: false,
                  completed: false,
                  type: rest.name
                })
  
              }
  
            } else {
  
              projects.push({ ...rest, 
                materials: [],
                description: '',
                name: `${rest.name} (${j + 1})`,
                selected: false,
                completed: false,
                type: rest.name
              })
  
            }
  
          }
  
      } else {
  
            const { counter, ...rest } = selectedProjects[i]
  
            if (project_list.length > 0) {
  
              const filterCompleted = project_list.find(proj => proj.completed && proj.type === selectedProjects[i].name)
  
              if (filterCompleted) {
                
                projects.push({ ...filterCompleted })
  
              } else {
                
                projects.push({ ...rest,
                  materials: [],
                  description: '',
                  selected: false,
                  completed: false,
                  type: rest.name
                })
  
              }
  
            } else {
  
              projects.push({ ...rest,
                materials: [],
                description: '',
                selected: false,
                completed: false,
                type: rest.name
              })
  
            }
      }
    }
  
    let selectProject = projects.map((proj, index) => {
      
      let curItem = { ...proj }
      
      curItem.selected = false
  
      return curItem
  
    })
  
    return selectProject
  }
  
  const selectProject = ({ item, currentItem, projectMaterial, completed }, projects) => {
  
    let copy = [ ...projects ]
  
    copy = copy.map(curItem => {
      
      let itemCopy = { ...curItem }
  
      if (itemCopy.selected) {
  
        itemCopy.materials = projectMaterial
  
        itemCopy.completed = completed ? true : false
  
        itemCopy.description = currentItem ? currentItem.description : ''
  
        return itemCopy
      }
  
      return curItem
  
    })
  
    return copy.map(cur => {
  
      if (cur.name === item.name) {
        cur.selected = true
      } else {
        cur.selected = false
      }
      
      return cur
    })
    
  }
  
  const deleteNotCompleted = (item, projects) => {
  
    let copy = [ ...projects ]
  
    const indexOf = copy.findIndex(proj => !proj.completed && proj.type === item.name)
  
    if (indexOf > 0) {
  
      const filter = copy.filter((cur, key) => key !== indexOf)
    
      return filter
    }
    
    return copy
  
  }
  
  const deleteProject = (item, projects) => {
  
    let copy = [ ...projects ]
  
    let filter = copy.filter(cur => cur.name !== item.name)
  
    filter = filter.map(( item, index ) => {
        
      if (index === 0) {
        return {
          ...item, selected: true
        }
      }
  
        return item
  
    })
  
    return filter
  
  }
  
  const removeProject = (item, projects) => {
  
    let copy = [ ...projects ]
  
    if (copy.length > 1) {
  
      let filter = copy.filter(cur => cur.name !== item.name)
  
      filter = filter.map(( item ) => {
        
        let itemcopy = { ...item }
  
        itemcopy.selected = false
  
        return itemcopy
  
      })
  
      return filter
  
    }
  
    return copy
  }
  
  const updateProject = ({ currentItem, projectMaterial }, projects) => {
  
    let copy = [ ...projects ];
  
    copy = copy.map(item => {
  
      let itemCopy = { ...item }
      
      if (itemCopy.selected) {
  
        itemCopy.materials = projectMaterial ? projectMaterial.filter(item => item.name) : []
  
        itemCopy.description = currentItem.description
  
        return itemCopy
      }
  
      return item
  
    })
  
    return copy
  
  }
  
  const updateProjectAndNext = ({ currentItem, projectMaterial }, projects) => {
  
    let copy = [ ...projects ];
    
    copy = copy.map(item => {
  
      let itemCopy = { ...item }
  
      if (itemCopy.name === currentItem.name) {
  
        itemCopy.materials = projectMaterial
  
        itemCopy.completed = true
  
        itemCopy.description = currentItem.description
  
        return itemCopy
      }
  
      return item
  
    })
  
    const indexOf = copy.map(item => item.selected).indexOf(true)
  
    if (copy.length > 1) {
  
        let nextIndesSelected = 0;
      
        if (indexOf === 0) {
            nextIndesSelected = 1
        }
  
        if (indexOf > 0 && indexOf < copy.length) {
            nextIndesSelected = indexOf + 1
        }
  
        if (indexOf > 0 && indexOf === copy.length - 1) {
            nextIndesSelected = 0
        }
  
        copy = copy.map(( curItem, index) => {
  
          let copyItem = { ...curItem }
  
          if (index === nextIndesSelected) {
              copyItem.selected = true
          } else {
              copyItem.selected = false
          }
  
          return copyItem
  
        })
  
        return copy
  
    }
  
    return copy
    
  }
  
  const updateSelectedMaterialsList = (item, list, action) => {
  
    let newList = [ ...list ]
  
    if (action) {
  
        if (Array.isArray(item)) {
          newList = [ ...newList, ...item ]
        }
      
        if (item instanceof Object) {
          newList.push(item)
        }
      
        
        const cleanList = [ ...new Set(newList)]
        
        return cleanList.filter(cur => !Array.isArray(cur))
  
    } 

    const result = newList.filter(curItem => curItem.name !== item.name)

    return result
  
  }
  
  const removeUploadFile = (files, file) => {
  
    let newList = [ ...files ]
  
    if (file) {
  
      const updated = newList.filter(item => item.name !== file.name)
      
      return updated
  
    }
  
    return newList
  
  }
  
  const projectUserReducer = (state, actions) => {
      const { type, payload } = actions
  
      switch (type) {
          case SET_PROJECT_NAME:
            return {
                ...state,
                project_name: payload,
            }
          case SET_PROJECT_EMAIL:
            return {
                ...state,
                project_email: payload,
            }
          case SET_USER_TYPE: 
            return {
              ...state,
              user_type: payload
            }
          case CREATE_AMBIENTES: 
            return {
              ...state,
              projects: createProjects(state.ambients, state.projects)
            }
          case PLUS_MINUS_SELECT:
            return {
              ...state,
              ambients: updateAmbientsCounter(state.ambients, payload.ambient, payload.action)
            }
          case SET_PROJECT_MATERIALS:
            return {
              ...state,
              projects_materials: updateSelectedMaterialsList(payload, state.projects_materials, true)
            }
          case UNSET_PROJECT_MATERIALS: {
            return {
              ...state,
              projects_materials: updateSelectedMaterialsList(payload, state.projects_materials, false)
            }
          }
          case SET_STEP_DONE:
            return {
              ...state,
              steps: updateStepsComplete(payload, state.steps)
            }
          case SELECT_AMBIENT_EDIT:
            return {
              ...state,
              projects: selectProject(payload, state.projects)
            }
          case REMOVE_PROJECT_AMBIENT:
            return {
              ...state,
              projects: removeProject(payload, state.projects)
            }
          case DELETE_PROJECT_AMBIENT:
            return {
              ...state,
              projects: deleteProject(payload, state.projects)
            }
          case DELETE_PROJECT_AMBIENT_NOT_COMPLETED:
            return {
              ...state,
              projects: deleteNotCompleted(payload, state.projects)
            }
          case EDIT_NEXT_PROJECT:
            return {
              ...state,
              projects: updateProjectAndNext(payload, state.projects)
            }
          case SET_UPLOAD_FILE: 
            return {
              ...state,
              files: payload
            }
  
          case REMOVE_UPLOAD:
            return {
              ...state,
              files: removeUploadFile(state.files, payload)
            }
          case UPDATE_CURRENT_PROJECT: 
            return {
              ...state,
              projects: updateProject(payload, state.projects)
            }
          case START_PROJECT:
            return {
              ...state,
              project_started: payload
            }
          case FROM_COMPARATOR_NATERIALS: {
            return {
              ...state,
              from_comparator: true
            }
          }
          case SET_FROM_COMPARATOR_NATERIALS: {
            return {
              ...state,
              from_comparator: false
            }
          }
          case GOT_IN_MOODBOARD: {
            return {
              ...state,
              got_in_moodboard: true
            }
          }
          case PROJECT_WAS_SENT: {
            return {
              ...state,
              project_was_sent: payload
            }
          }
          case SET_PROJECT_CODE: {
            return {
              ...state,
              project_code: payload
            }
          }
          case CLEAR_STATE: {
            return {
              steps: [{
                key: STEP_PROJECT_NAME,
                completed: false
              },{
                key: 2,
                completed: false
              }],
              project_started: false,
              project_name: '',
              project_email: '',
              user_type: '',
              materials: [],
              projects: [],
              projects_materials: [],
              files: [],
              from_comparator: false,
              got_in_moodboard: false,
              project_was_sent: false,
              project_code: null,
              ambients: [{
                name: 'cozinha',
                mobile_picture: Kitchen,
                desktop_picture: KitchenDesk,
                counter: 0
              },{
                name: 'churrasqueira',
                mobile_picture: Grill,
                desktop_picture: GrillDesk,
                counter: 0
              },{
                name: 'área de serviço',
                mobile_picture: ServiceArea,
                desktop_picture: ServiceAreaDesk,
                counter: 0
              },{
                name: 'lavabo',
                mobile_picture: Toilet,
                desktop_picture: ToiletDesk,
                counter: 0
              },{
                name: 'lareira',
                mobile_picture: FirePlace,
                desktop_picture: FirePlaceDesk,
                counter: 0
              },{
                name: 'banheiro',
                mobile_picture: Bathroom,
                desktop_picture: BathroomDesk,
                counter: 0
              },{
                name: 'escadas',
                mobile_picture: Stairs,
                desktop_picture: StairsDesk,
                counter: 0
              },{
                name: 'soleira e baguete',
                mobile_picture: Threshold,
                desktop_picture: ThresholdDesk,
                counter: 0
              },{
                name: 'piso e revestimento',
                mobile_picture: FloorAndThreshold,
                desktop_picture: FloorAndThresholdDesk,
                counter: 0
              },
              {
                name: 'outros',
                mobile_picture: Others,
                desktop_picture: OthersDesk,
                counter: 0
              }]
            }
          }
          default: {
            return state
          }
      }
  }
  
  export { projectUserReducer as default, projectUserState }